const focusedByPointer = new WeakSet<HTMLInputElement>();

export function notePointerFocus(input: HTMLInputElement): void {
  if (document.activeElement !== input) focusedByPointer.add(input);
}

export function selectUnlessPointerFocus(input: HTMLInputElement): void {
  if (focusedByPointer.delete(input)) return;
  requestAnimationFrame(() => {
    if (document.activeElement === input) input.select();
  });
}
